module.exports = __webpack_public_path__ + "media/images/review/ico-crown-s-d60d2507c514198cc5be65315881e244.svg";